var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAttach = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7434 12.697L11.0866 19.2311C5.70513 24.5136 -2.22065 16.7115 2.3815 12.1944L12.6227 2.14195C16.2135 -1.3826 20.822 4.14612 18.2554 6.66554L8.52638 16.2152C6.72889 17.9796 4.16872 15.4664 5.96607 13.7022L15.1832 4.65507",
    stroke: "#3C6FF5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAttach);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/attach.76e639bdef777d153139c88cd54b102a.svg";